module.exports = __webpack_public_path__ + "static/Kroger_pin_hover-c36ef4e62bdff8a1c4f3d9c95b5b78a6.png";